<template>
  <div class="personal-view">
    <div class="menu">
      <menu-list></menu-list>
    </div>
    <div class="content">
      <div class="left-nav">
        <sidebar-two
        :defaultActive="defaultActive"
        :title="sidebarTwoTitle"
        :list="sidebarTwoList"
        @selectMenu="selectMenu"></sidebar-two>
      </div>
      <div class="right-middle">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '@/base/menu/menu'
import SidebarTwo from '@/base/sidebar2/sidebar2'
export default {
  name: '',
  components: {
    'menu-list': Menu,
    'sidebar-two': SidebarTwo
  },
  data () {
    return {
      msg: '个人中心',
      sidebarTwoTitle: '个人中心',
      defaultActive: '',
      sidebarTwoList: [{
        id: '1',
        text: '我的书架',
        pathName: 'MyBookshelf',
        path: '/home/personal/mybookshelf'
      }, {
        id: '2',
        text: '我的订单',
        pathName: 'MyOrder',
        path: '/home/personal/myorder'
      }, {
        id: '3',
        text: '我的收藏',
        pathName: 'MyCollection',
        path: '/home/personal/mycollection'
      },
      // {
      //   id: '4',
      //   text: '我的购书记录',
      //   pathName: 'MyRecord',
      //   path: '/home/personal/myrecord'
      // },
      // {
      //   id: '5',
      //   text: '我的优惠卷',
      //   pathName: 'MyCoupon',
      //   path: '/home/personal/mycoupon'
      // },
      {
        id: '4',
        text: '账号设置',
        pathName: 'Settings',
        path: '/home/personal/settings'
      }]
    }
  },
  methods: {
    selectMenu (obj) {
      this.$router.push({
        name: this.sidebarTwoList[obj.id - 1].pathName
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .personal-view{
    .menu{
      margin: 20px auto;
      width: 600px;
    }
    .content{
      display: flex;
      .left-nav{
        width: 200px;
      }
      .right-middle{
        flex: 1;
        margin-left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/personal.vue


// WEBPACK FOOTER //
// src/components/Personal/personal.vue